module.exports = __webpack_public_path__ + "static/media/dm.b1635699.svg";